import { createSvgIcon } from '@mui/material/utils';
export default createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13">
        <g>
            <polygon
                fill="currentColor"
                className="d"
                points="9 4 9 0 0 0 0 9 4 9 4 4 9 4"
            />
            <polygon
                fill="currentColor"
                className="d"
                points="9 4 9 9 4 9 4 13 13 13 13 4 9 4"
            />
        </g>
    </svg>,
    'React'
);
